import React from 'react';
import dayjs from 'dayjs';
import Typography from '@mui/material/Typography';

import type { IShowing } from 'src/api/landlord-showings-api';
import type { ILead } from 'src/services/api';
import ExpandableItem from 'src/components/lead-sidebar/LeadSidebarExpandableItem';
import Tour from 'src/components/lead-sidebar/LeadSidebarTour';

interface Props {
    lead: ILead,
    showings: IShowing[],
}

export default function LeadSidebarUpcomingTour({
    lead,
    showings,
}: Props) {
    const upcomingTours = showings
        .filter((showing) =>
            showing.lead_uuid === lead.uuid && !dayjs(showing.start_time).isBefore(dayjs())
        )
        // Soonest first: start_time is an absolute instant, so a lexicographic
        // compare of the ISO strings is not reliable across offsets — compare the
        // parsed moments.
        .sort((a, b) => dayjs(a.start_time).valueOf() - dayjs(b.start_time).valueOf());

    return (
        <ExpandableItem title="Upcoming Tours" defaultExpanded={upcomingTours.length > 0}>
            {upcomingTours.length > 0 ? (
                upcomingTours.map((showing) => (
                    <Tour
                        key={showing.id}
                        lead={lead}
                        showing={showing}
                        color="var(--primary-color)"
                    />
                ))
            ) : (
                <Typography variant="body2" color="grey">No Upcoming tours</Typography>
            )}
        </ExpandableItem>
    );
}
